import { useTranslation } from "react-i18next";
import { ButtonV2 } from "#src/commonV2/Button";

interface PassportModalFooterProps {
  isEditing: boolean;
  isDataValid: boolean;
  isLoading: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export const PassportModalFooter = ({
  isEditing,
  isDataValid,
  isLoading,
  onSave,
  onCancel,
}: PassportModalFooterProps) => {
  const { t } = useTranslation("endpoint", { keyPrefix: "passports" });

  return (
    <div className="flex gap-2 justify-end mt-8">
      <ButtonV2 variant="secondary" size="md" color="gray" onClick={onCancel}>
        <p>{t("modal.addAndEdit.button.cancel")}</p>
      </ButtonV2>

      <ButtonV2
        variant="primary"
        size="md"
        disabled={!isDataValid}
        pending={isLoading}
        onClick={onSave}
      >
        <p>{t(`modal.addAndEdit.button.${isEditing ? "save" : "add"}`)}</p>
      </ButtonV2>
    </div>
  );
};
